import fetchMock from 'fetch-mock';
import noUiSlider from 'nouislider';
import autocomplete from 'autocompleter';

window.gesundeGemeindeData = window.gesundeGemeindeData || {
  htmlNodes: {},
}

// start mock-definitions

fetchMock.post('https://tutgut.at/list/result', {
  list: [
    {
      name: 'ww_ind_Ort001',
      distance: 2500,
      difficulty: 'medium',
      duration: 3600, // 1h
    },
    {
      name: 'ww_ind_Ort002',
      distance: 3000,
      difficulty: 'hard',
      duration: 7200, // 2h
    },
    {
      name: 'ww_ind_Ort003',
      distance: 2500,
      difficulty: 'easy',
      duration: 1800, // 0,5h
    },
  ],
});

fetchMock.post('https://tutgut.at/regions', {
  regionalberater: [
    {
      id: 0,
      vorname: 'Hans',
      nachname: 'Maulwurf',
      job: 'Sachbearbeiter',
      image: 'assets/images/logo.png',
      gender: 'm',
    },
    {
      id: 1,
      vorname: 'John',
      nachname: 'Doe',
      job: 'Berater',
      image: 'assets/images/noe-logo.png',
      gender: 'm',
    }
  ],
  regions: [
    {
      id: 0,
      name: 'Industrieviertel',
      places: [
        {
          id: 1000,
          name: 'ww_ind_Ort001_Albrechtsberg_an_der_grossen_Krems',
          employeeId: 0,
          address: 'AABBB',
          plz: '2222',
          url: 'https://www.google.com',
          lat: 48.46229719999999,
          lng: 15.368461600000046,
        },
        {
          id: 1001,
          name: 'ww_ind_Ort002',
          employeeId: 1,
          address: 'CCCCC',
          plz: '3333',
          url: 'https://www.orf.at',
        },
        {
          id: 1002,
          name: 'ww_ind_Ort003',
          employeeId: 0,
          address: 'DDDD',
          plz: '4444',
          url: 'https://www.derstandard.at',
        }
      ]
    },
    {
      id: 1,
      name: 'Mostviertel',
      places: [
        {
          id: 1100,
          name: 'ww_most_Ort001',
          employeeId: 0,
          address: 'CCCCC',
          plz: '3333',
          url: 'https://www.orf.at',
        },
        {
          id: 1101,
          name: 'ww_most_Ort002_Alberndorf_im_Pulkautal',
          employeeId: 0,
          lat: 48.7049057,
          lng: 16.09980399999995,
        },
        {
          id: 1102,
          name: 'ww_most_Ort003',
          employeeId: 0,
        }
      ]
    },
    {
      id: 2,
      name: 'NÖ Mitte',
      places: [
        {
          id: 1200,
          name: 'ww_mitt_Ort001_Allhartsberg',
          address: 'CCCCC',
          plz: '3333',
          url: 'https://www.orf.at',
          employeeId: 0,
          lat: 48.0267108,
          lng: 14.792379200000027
        },
        {
          id: 1201,
          name: 'ww_mitt_Ort002',
          employeeId: 0,
        },
        {
          id: 1202,
          name: 'ww_mitt_Ort003',
          employeeId: 0,
        }
      ]
    },
    {
      id: 3,
      name: 'Waldviertel',
      places: [
        {
          id: 1300,
          name: 'ww_wald_Ort001_Altendorf',
          employeeId: 0,
          address: 'CCCCC',
          plz: '3333',
          url: 'https://www.orf.at',
          lat: 47.6601143,
          lng: 16.016132500000026,
        },
        {
          id: 1301,
          name: 'ww_wald_Ort002',
          employeeId: 0,
        },
        {
          id: 1302,
          name: 'ww_wald_Ort003',
          employeeId: 0,
        }
      ]
    },
    {
      id: 4,
      name: 'Weinviertel',
      places: [
        {
          id: 1400,
          name: 'ww_wein_Ort001_Absdorf',
          employeeId: 0,
          lat: 48.3995637,
          lng: 15.979998000000023,
        },
        {
          id: 1401,
          name: 'ww_wein_Ort002',
          employeeId: 0,
        },
        {
          id: 1402,
          name: 'ww_wein_Ort003',
          employeeId: 0,
        }
      ]
    },
  ]
});

// end mock-definitions

const initGesundeGemeindeData = () => {
  window.gesundeGemeindeData.htmlNodes = {
    regionsEntrypoint: document.querySelector('.regions-entrypoint'),
    regionalberaterEntrypoint: document.querySelector('.regionalberater-entrypoint'),
    searchInput: document.querySelector('.c-gesundegemeinde__select-1 .c-form__input'),
    searchInputWrapper: document.querySelector('.c-gesundegemeinde__searchbar-wrapper'),
  }
  initGesundeGemeindeDataFromServer();
}

const initGesundeGemeindeDataFromServer = () => {
  fetch('https://tutgut.at/regions', {
    method: 'post'
  }).then(response => response.json())
  .then(response => {
    window.gesundeGemeindeData.regions = response.regions;
    window.gesundeGemeindeData.regionalberater = response.regionalberater;
    response.regions.map(region => {
      let accordionHeader = document.createElement('h2');
      let accordionPanel = document.createElement('div');
      accordionHeader.innerHTML = region.name;
      accordionHeader.classList.add('js-accordion__header');
      accordionPanel.setAttribute("data-id", region.id);
      accordionPanel.classList.add('js-accordion__panel');
      accordionPanel.innerHTML = `
        <ul>
          ${
            region.places.map(place => {
              return '<li data-id="'+place.id+'">'
                + '<a href="#" onclick="window.gesundeGemeindeData.changeDisplayMode(event, \'gemeinde\', { id: '+place.id+' })">'
                + place.name
                + '</a>'
                + '</li>'
              ;
            }).join('')
          }
        </ul>
      `;
      window.gesundeGemeindeData.htmlNodes.regionsEntrypoint.appendChild(accordionHeader);
      window.gesundeGemeindeData.htmlNodes.regionsEntrypoint.appendChild(accordionPanel);
    });
   let rbMarkup = '<ul>';
    response.regionalberater.map(rb => {
      rbMarkup += `
        <li data-id="rbb${rb.id}">
          <a href="#" onclick="window.gesundeGemeindeData.changeDisplayMode(event, 'gemeinde_list', {regionalberaterId: '${rb.id}'})">${rb.vorname} ${rb.nachname}</a>
        </li>
      `;
    });
    rbMarkup += '</ul>';
    let accordionHeader = document.createElement('h2');
    let accordionPanel = document.createElement('div');
    accordionHeader.innerHTML = 'RegionalberaterIn';
    accordionHeader.classList.add('js-accordion__header');
    accordionPanel.setAttribute("data-id", "rb0");
    accordionPanel.classList.add('js-accordion__panel');
    accordionPanel.innerHTML = rbMarkup;
    window.gesundeGemeindeData.htmlNodes.regionalberaterEntrypoint.appendChild(accordionHeader);
    window.gesundeGemeindeData.htmlNodes.regionalberaterEntrypoint.appendChild(accordionPanel);
    var expand_default = window.van11yAccessibleAccordionAria();
    expand_default.attach();
    document.querySelector('.regions-entrypoint').classList.add('has-data');
    document.querySelector('.regionalberater-entrypoint').classList.add('has-data');
    if (window.gesundeGemeindeData.autocomplete) {
      window.gesundeGemeindeData.autocomplete.destroy();
    }
    window.gesundeGemeindeData.autocomplete = autocomplete({
      input: window.gesundeGemeindeData.htmlNodes.searchInput,
      fetch: function(text, update) {
          text = text.toLowerCase();
          // you can also use AJAX requests instead of preloaded data
          let placesTmpArr = response.regions.map(region => region.places);
          let placesArr = [];
          placesTmpArr.map(place => {
            placesArr = [
              ...placesArr,
              ...place
            ];
          });
          var suggestions = placesArr.filter(n => n.name.toLowerCase().startsWith(text));
          suggestions = suggestions.map(s => ({label: s.name, value: s.id}));
          update(suggestions);
      },
      preventSubmit: true,
      onSelect: function(item) {
        window.gesundeGemeindeData.htmlNodes.searchInput.value = item.label;
        window.gesundeGemeindeData.changeDisplayMode(null, 'gemeinde', { id: item.value });
      }
    });
    window.gmInitInterval = window.setInterval(() => {
      if (google && MarkerClusterer) {
        googleMapsInitMarkers();
        window.clearInterval(window.gmInitInterval);
        window.gmInitInterval = null;
      }
    }, 500);
  });
}

const changeDisplayMode = (ev, mode, payload) => {
  if (ev) {
    ev.preventDefault();
  }
  if (String(mode).toLowerCase() == 'gemeinde') {
    if (!payload || !payload.id) {
      return;
    }
    else {
      let place = getPlaceData(payload.id);

      window.gesundeGemeindeData.googleMap.setCenter(new google.maps.LatLng(place.lat, place.lng));

      let employee = getEmployeeData(payload.id);
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-default');
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde');
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde_list');

      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.add('c-gesundegemeinde__mode-gemeinde');

      let textInfoNode = document.querySelector('.c-gesundegemeinde__gemeinde-infobox');
      textInfoNode.innerHTML = `
        <div class="c-gesundegemeinde__gemeinde-infobox-name">${place.name}</div>
        <div class="c-gesundegemeinde__gemeinde-infobox-address">
          <div class="c-gesundegemeinde__gemeinde-infobox-address-row">${place.address},</div>
          <div class="c-gesundegemeinde__gemeinde-infobox-plz">${place.plz}</div>
          <div class="c-gesundegemeinde__gemeinde-infobox-placename">${place.place || place.name}</div>
        </div>
        <a
          class="c-gesundegemeinde__gemeinde-infobox-website-button c-btn"
          href="${place.url}"
          target="_blank"
        >
          zur Website
        </a>
      `;

      let regionalberaterNode = document.querySelector('.c-gesundegemeinde__gemeinde-regionalberater-box');
      regionalberaterNode.innerHTML = `
        <div class="c-gesundegemeinde__gemeinde-regionalberater-box-pic-wrapper">
          <img src="${employee.image}" alt="${employee.vorname} ${employee.nachname}">
        </div>
        <div class="c-gesundegemeinde__gemeinde-regionalberater-box-box">
          <div class="c-gesundegemeinde__gemeinde-regionalberater-name">
            ${employee.vorname} ${employee.nachname}
          </div>
          <div class="c-gesundegemeinde__gemeinde-regionalberater-job">
            ${employee.job}
          </div>
        </div>
        <div class="c-gesundegemeinde__gemeinde-regionalberater-footer">
        </div>
      `;
    }
  }
  else if (String(mode).toLowerCase() == 'gemeinde_list') {
    if (payload && payload.regionalberaterId) {
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-default');
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde');
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde_list');
  
      window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.add('c-gesundegemeinde__mode-gemeinde_list');
      let cardlistNode = document.querySelector('.c-gesundegemeinde__gemeinde_list-cardlist');
      cardlistNode.innerHTML = "<b>XXX</b>";

      let regionalberater = window.gesundeGemeindeData.regionalberater.find(berater => berater.id == payload.regionalberaterId);
      console.log("tetet", regionalberater);

      let cardlistMarkup = `
        <div class="c-gesundegemeinde__gemeinde_list-headline">
        Regionalberater${String(regionalberater.gender).toLowerCase() == 'w' ? 'in' : ''} ${regionalberater.vorname} ${regionalberater.nachname}
        </div>
      `;
      let placeList = getPlacesForRegionalberater(payload.regionalberaterId);
      placeList.map(place => {
        cardlistMarkup += `
          <a class="c-gesundegemeinde__gemeinde_list-entry c-gesundegemeinde__card"
            onclick="window.gesundeGemeindeData.changeDisplayMode(event, 'gemeinde', { id: ${place.id} })"
            href="#"
          >
            <div class="c-gesundegemeinde__gemeinde_list-placename">
              ${place.name}
            </div>
            <div class="c-gesundegemeinde__gemeinde_list-address">
              <div class="c-gesundegemeinde__gemeinde_list-address-row">
                ${place.address}
              </div>,
              <div class="c-gesundegemeinde__gemeinde_list-address-plz">
                ${place.plz}
              </div>
              <div class="c-gesundegemeinde__gemeinde_list-address-placename">
                ${place.place || place.name}
              </div>
            </div>
          </a>
        `;
      });

      cardlistNode.innerHTML = cardlistMarkup;

    }
    else {
      return;
    }
  }
  else {
    window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-default');
    window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde');
    window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.remove('c-gesundegemeinde__mode-gemeinde_list');

    window.gesundeGemeindeData.htmlNodes.searchInputWrapper.classList.add('c-gesundegemeinde__mode-default');
  }
}
window.gesundeGemeindeData.changeDisplayMode = changeDisplayMode;

const getPlacesForRegionalberater = regionalberaterId => {
  let flatPlaces = [];
  window.gesundeGemeindeData.regions.map(region => {
    let curPlaces = [...region.places];
    curPlaces.map(curPlace => {
      curPlace.regionId = region.id;
      return curPlace;
    });
    flatPlaces = [...flatPlaces, ...curPlaces];
  });
  flatPlaces = flatPlaces.filter(flatPlace => flatPlace.employeeId == regionalberaterId);
  return flatPlaces;
}

const getPlaceData = id => {
  let regionForPlaceId = window.gesundeGemeindeData.regions.find(region => region.places.find(place => place.id == id));
  return regionForPlaceId.places.find(place => place.id == id);
}

// param id is place-id
const getEmployeeData = id => {
  if (!window.gesundeGemeindeData || !window.gesundeGemeindeData.regionalberater) {
    return;
  }
  if (id) {
    let regionForPlaceId = window.gesundeGemeindeData.regions.find(region => region.places.find(place => place.id == id));
    return window.gesundeGemeindeData.regionalberater.find(berater => berater.id == regionForPlaceId.places.find(place => place.id == id).employeeId);
  }
  else {
    return window.gesundeGemeindeData.regionalberater;
  }
}

const googleMapsInitMarkers = () => {
  if (!MarkerClusterer || !google) {
    return;
  }
  let image = 'assets/images/icons/pin.png';
  let markerID = -1;
  let markers = [];
  window.gesundeGemeindeData.regions.map(region => {
    region.places.map(place => {
      markerID = markerID + 1;
      let googleMarker = new google.maps.Marker({
        id: markerID,
        position: new google.maps.LatLng(String(place.lat || 1).replace(",", "."), String(place.lng || 1).replace(",", ".")),
        icon: image,
        bezirk: '.BEZIRK' + place.id,
        region: '.REGION' + region.id,
        berater: '.BERATER' + place.employeeId,
        alphabet: place.name.replace("'", "\'").substr(0,1).toUpperCase(),
        animation: google.maps.Animation.DROP,
      });
      google.maps.event.addListener(googleMarker, 'click', () => {
        window.gesundeGemeindeData.changeDisplayMode(null, 'gemeinde', { id: parseInt(String(googleMarker.bezirk).replace('.BEZIRK', '')) });
      });
      markers.push(googleMarker);
    });
  });

  let mapElement = document.querySelector(".google-map")
  let map = new google.maps.Map(mapElement, {
    center: { lat: 48.210033, lng: 16.363449 },
    zoom: 9,
  });

  let searchbarWrapper = document.querySelector(".c-gesundegemeinde__searchbar-wrapper")
  let searchBtnMobile = document.createElement("button")
  searchBtnMobile.classList.add('c-btn')
  searchBtnMobile.innerHTML = 'Gesunde Gemeinde suchen'
  searchBtnMobile.addEventListener(
    "click",
    (event) => { searchbarWrapper.style.display = 'block'}
  );
    
  mapElement.appendChild(searchBtnMobile)

  document.querySelector(".c-gesundegemeinde__place-selector__header .c-dialog__close").addEventListener(
    "click",
    (event) => {searchbarWrapper.style.display = 'none'}
  );

  MarkerClusterer.prototype.getDraggable = function() { return false; };
  new MarkerClusterer(map, markers, {
    imagePath:
      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  });
  window.gesundeGemeindeData.googleMap = map;
}

initGesundeGemeindeData();